<template>
  <div>
    <NavigationDrawer app>
    </NavigationDrawer>
    <Navbar></Navbar>
    <AlertPanel />
    <router-view></router-view>
  </div>
</template>

<script>
import Navbar from '@/components/layout/admin/Navbar'
import AlertPanel from '@/components/layout/AlertPanel'
import NavigationDrawer from './NavigationDrawer'
export default {
  name: 'Layout',
  components: { NavigationDrawer, AlertPanel, Navbar }
}
</script>

<style scoped>
>>>.table-link{
  text-decoration: none;
}
</style>
